import http from './solfacil-plus-api.http'

export async function getPartnerArrearsList(partnerId: string) {
  const response = await http.get(`/partner/${partnerId}/list-arrears`)
  return response.data.data
}

export async function getPartnerSolfacilPlusInfo(partnerId: string) {
  const response = await http.get(`/partner/${partnerId}`)
  return response.data.data
}
